module.exports = __webpack_public_path__ + "98c68ee15f7008d0f311c9cc1bb05c5c.svg";